import { fetchReviews } from "../services/pgoApi";
import { renderCategoryScores, generateStars } from "../utils/pgoStarsUtils";

export const reviewRenderer = (pgoId) => ({
    pgoId: pgoId,
    reviews: [],
    review: {},
    currentPageIndex: 1,
    reviewsPerPage: 4,
    loading: false,
    sortBy: "new_first",
    error: false,
    totalCount: 0,
    titleId: "bf380f35-4616-4be0-826c-5b477df90341",
    prosConsId: "3f167ead-7810-430f-b1ae-4ad595e3f33c",

    init() {
        this.getData();
    },

    async getData() {
        this.loading = true;

        try {
            const offset = (this.currentPageIndex - 1) * this.reviewsPerPage;
            const afterCursor = offset > 0 ? btoa(offset.toString()) : null;

            const { nodes, totalCount } = await fetchReviews(
                this.pgoId,
                afterCursor,
                this.reviewsPerPage,
                this.sortBy
            );

            if (!nodes.length) {
                this.error = true;
                console.error("No reviews found");
                return;
            }

            this.totalCount = totalCount;
            this.reviews = nodes;

            this.error = false;
        } catch (error) {
            this.error = true;
            console.error("Error fetching reviews:", error);
        } finally {
            this.loading = false;
        }
    },

    setReview(reviewId) {
        this.review = this.reviews.find((review) => review.id === reviewId);
    },

    getTitle() {
        return this.review.answers.find((a) => a.question.id === this.titleId)?.value || 'Geen reactie.';
    },

    getDate() {
        return new Date(this.review.publicationDate).toLocaleDateString();
    },

    getProsCons() {
        const value = this.review.answers.find((a) => a.question.id === this.prosConsId)?.value || "{}";
        return JSON.parse(value) || { pros: [], cons: [] };
    },

    getAverageStarRating() {
        return generateStars(this.review.averageScore ? this.review.averageScore : 0);
    },

    getAllRatings() {
        return this.review.score.categoryScores.length > 0 ? renderCategoryScores(this.review.score.categoryScores) : "";
    },

    updatePage(page) {
        this.currentPageIndex = page;
        this.getData();
    },

    getVisiblePageNumbers() {
        const totalPages = Math.ceil(this.totalCount / this.reviewsPerPage);
        const visiblePages = 5;
        const halfRange = Math.floor(visiblePages / 2);
        let startPage = Math.max(1, this.currentPageIndex - halfRange);
        let endPage = Math.min(totalPages, startPage + visiblePages - 1);

        return Array.from({ length: endPage - startPage + 1 }, (_, i) => startPage + i);
    },

    getTotalPages() {
        return Math.ceil(this.totalCount / this.reviewsPerPage);
    },

    sortReviews(event) {
        this.sortBy = event.target.value;
        this.currentPage = { after: null, before: null };
        this.getData();
    },

    scrollToTop() {
        const container = document.getElementById("reviews");
        container
            ? container.scrollIntoView({ behavior: "smooth" })
            : window.scrollTo({ top: 0, behavior: "smooth" });
    }
});